// src/pages/Privacy.js
import React from 'react';
import { Container, Typography, Paper } from '@mui/material';

const Privacy = () => {
    return (
        <Container maxWidth="lg">
            <Paper elevation={0} sx={{ p: 4, my: 4 }}>
                <Typography variant="h4" gutterBottom>
                    Privacy Policy
                </Typography>
                <Typography variant="body2" color="text.secondary" paragraph>
                    Last Updated: January 25, 2025
                </Typography>

                <Typography paragraph sx={{ mt: 3 }}>
                    ArgusCMS is a product developed by wpAppDev, a division of iMarket LLC. This privacy policy has been compiled to better serve those who are concerned with how their 'Personally identifiable information' (PII) is being used online. PII, as used in US privacy law and information security, is information that can be used on its own or with other information to identify, contact, or locate a single person, or to identify an individual in context. Please read our privacy policy carefully to get a clear understanding of how we collect, use, protect or otherwise handle your Personally Identifiable Information in accordance with our website.
                </Typography>

                <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
                    ArgusCMS-Specific Data Collection and Usage
                </Typography>
                <Typography paragraph>
                    In addition to the standard information collection practices outlined below, ArgusCMS specifically collects and processes:
                </Typography>
                <Typography component="ul" sx={{ pl: 3 }}>
                    <li>Contact lists and email campaign data</li>
                    <li>AI-generated content and custom instructions</li>
                    <li>Email templates and customization preferences</li>
                    <li>Campaign analytics and performance data</li>
                </Typography>

                {/* Original content starts here */}
                <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
                    What personal information do we collect from the people that visit our blog, website or app?
                </Typography>
                
                {/* Continue with all existing sections, keeping original formatting */}
                {/* ... (all existing content) ... */}

                <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
                    Data Security for ArgusCMS Services
                </Typography>
                <Typography paragraph>
                    For ArgusCMS users, we implement additional security measures including:
                </Typography>
                <Typography component="ul" sx={{ pl: 3 }}>
                    <li>Encryption of all contact lists and campaign data</li>
                    <li>Secure storage of AI instructions and generated content</li>
                    <li>Regular security audits of all stored data</li>
                    <li>Automated backup and recovery systems</li>
                </Typography>

                <Typography variant="h6" gutterBottom>
                        1. Information We Collect
                </Typography>
                <Typography paragraph>
                    We collect information you provide directly to us, including:
                </Typography>
                <Typography component="ul" sx={{ pl: 3 }}>
                    <li>Account information (name, email, business details)</li>
                    <li>Payment information (processed securely through Square)</li>
                    <li>Contact lists and email templates</li>
                    <li>Custom AI instructions and preferences</li>
                    <li>Campaign data and analytics</li>
                </Typography>

                <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
                    2. How We Use Your Information
                </Typography>
                <Typography paragraph>
                    We use the information we collect to:
                </Typography>
                <Typography component="ul" sx={{ pl: 3 }}>
                    <li>Provide, maintain, and improve our services</li>
                    <li>Process your transactions and send related information</li>
                    <li>Generate personalized content and communications</li>
                    <li>Analyze and optimize service performance</li>
                </Typography>

                <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
                    3. Data Storage and Security
                </Typography>
                <Typography paragraph>
                    We implement appropriate security measures to protect your data, including:
                </Typography>
                <Typography component="ul" sx={{ pl: 3 }}>
                    <li>Encryption of sensitive information</li>
                    <li>Secure storage of contact lists and campaign data</li>
                    <li>Protection of AI-generated content and custom instructions</li>
                    <li>Regular security audits and updates</li>
                </Typography>

                <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
                    4. Data Retention
                </Typography>
                <Typography paragraph>
                    We retain your information as long as your account is active or as needed to provide services. 
                    You may request deletion of your data at any time, subject to legal requirements and legitimate 
                    business purposes.
                </Typography>

                <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
                    5. Your Rights
                </Typography>
                <Typography paragraph>
                    You have the right to access, correct, or delete your personal information and data. 
                    Contact us for assistance with exercising these rights.
                </Typography>

                <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
                    Contacting Us
                </Typography>
                <Typography paragraph>
                    If there are any questions regarding this privacy policy you may contact us using the information below.
                </Typography>
                <Typography paragraph>
                    https://imarketllc.com/contact/<br />
                    info@imarketllc.com
                </Typography>

            </Paper>
        </Container>
    );
};

export default Privacy;